import {useRef} from 'react';
import {useCart, CartLineProvider, ClientAnalytics} from '@shopify/hydrogen';
import {CartLineItem, CartEmpty} from './index';
import {trackClickEvent} from '~/utils/trackClickEvent';

export function CartDetails({layout, onClose}) {
  const {lines, totalQuantity, cost} = useCart();
  const scrollRef = useRef(null);

  if (lines.length === 0) {
    return <CartEmpty onClose={onClose} layout={layout} />;
  } else {
    if (window.location.pathname === '/cart') {
      ClientAnalytics.publish('view_cart', true, {
        lines,
        cost,
      });
    }
  }

  return (
    <form
      className="cart cart__form"
      onSubmit={(evt) => {
        trackClickEvent('submit_cart_form');
        evt.preventDefault();
      }}
    >
      <section
        ref={scrollRef}
        aria-labelledby="cart-contents"
        className="cart-contents cart-contents__wrapper"
      >
        <h2 className="cart-contents cart-contents__title">
          Your Cart {totalQuantity > 0 && `(${totalQuantity})`}
        </h2>
        <ul className="cart-contents cart-contents__items">
          {lines.map((line) => {
            return (
              <CartLineProvider key={line.id} line={line}>
                <CartLineItem />
              </CartLineProvider>
            );
          })}
        </ul>
      </section>
    </form>
  );
}
